import { useEffect } from "react";
import { SITE } from "./site";

// Simple document head manager (no react-helmet dep required)
export function useSEO({ title, description, path = "" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE.name}` : `${SITE.name} — ${SITE.tagline}`;
    document.title = fullTitle;
    setMeta("description", description || SITE.subtag);
    setMeta("og:title", fullTitle, true);
    setMeta("og:description", description || SITE.subtag, true);
    setMeta("og:image", SITE.logo, true);
    setMeta("og:type", "website", true);
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", fullTitle);
    setMeta("twitter:description", description || SITE.subtag);
    setMeta("twitter:image", SITE.logo);

    // canonical
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${window.location.origin}${path || window.location.pathname}`;
  }, [title, description, path]);
}

function setMeta(name, content, isProp = false) {
  const key = isProp ? "property" : "name";
  let el = document.querySelector(`meta[${key}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(key, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}
